import { useRef } from 'react';

import { usePayroc } from './hooks/usePayroc';
import CardField from './components/CardField';
import PayOnlineButton from './PayOnlineButton';
import LoadingWrapper from './components/LoadingWrapper';
import SubmissionError from './components/SubmissionError';
import { useReportLoadError } from './hooks/useReportLoadError';
import { CARD_FIELDS, getDefaultCardFieldRows } from './lib/cardFieldRows';

import './Payroc.scss';

const PayrocOnlinePayment = ({
  id,
  amount,
  handlePayment,
  validate,
  children,
  buttonText,
  hideButton = false,
  mode,
  secureTokenId,
  flexRow,
  onError,
  terminalPin,
  fieldRows,
  onLoadError,
  getSessionToken,
  isFullWidthButton
}) => {
  const containerRef = useRef(null);
  const { isLoading, error, submitError, retry } = usePayroc({
    id,
    amount,
    validate,
    type: 'card',
    containerRef,
    handlePayment,
    buttonText,
    hideButton,
    mode,
    secureTokenId,
    terminalPin,
    getSessionToken,
    isFullWidthButton,
    onError
  });
  useReportLoadError({ onLoadError, error, retry });

  return (
    <LoadingWrapper
      isLoading={isLoading}
      error={error}
      retry={retry}
      id={id}
      hideError={!!onLoadError}>
      <div
        ref={containerRef}
        className="card-container payroc-form flex h-full w-full flex-col items-center justify-center gap-4 p-1">
        <SubmissionError message={submitError} />
        {(fieldRows ?? getDefaultCardFieldRows(flexRow)).map((row) => (
          <div key={row.fields.join('-')} className={row.className}>
            {row.fields.map((field) => (
              <CardField key={field} field={field} label={CARD_FIELDS[field].label} />
            ))}
          </div>
        ))}
        {children}
        {!hideButton && <PayOnlineButton payrocId={id} />}
      </div>
    </LoadingWrapper>
  );
};

export default PayrocOnlinePayment;
